/**
 * Yarn Haberdashery Section Script
 * Handles viewport reveal intersection observer, performance pausing when off-screen,
 * and Shopify Theme Customizer lifecycle events.
 */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function initSection(root) {
    if (!root || root.dataset.yhsInit === 'true') return;
    root.dataset.yhsInit = 'true';

    /* ---------- Viewport Intersection Observer ---------- */
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              root.classList.add('is-inview');
              root.classList.remove('is-offscreen');
            } else {
              root.classList.add('is-offscreen');
            }
          });
        },
        { threshold: 0.15 }
      );
      observer.observe(root);
    } else {
      root.classList.add('is-inview');
    }


  }

  function initAll() {
    document.querySelectorAll('[data-yhs-root]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* ---------- Theme Editor Listeners ---------- */
  document.addEventListener('shopify:section:load', function (event) {
    var sectionRoot = event.target.querySelector('[data-yhs-root]');
    if (sectionRoot) {
      initSection(sectionRoot);
    }
  });
})();
